import { ReactNode } from 'react';
import { Link } from 'react-router';

interface DappNavButtonProps {
  to: string;
  icon: ReactNode;
  label: string;
  isActive: boolean;
  showDraftBadge?: boolean;
  onClick?: () => void;
}

export const DappNavButton = ({
  to,
  icon,
  label,
  isActive,
  showDraftBadge,
  onClick,
}: DappNavButtonProps) => {
  return (
    <Link to={to} className="block" onClick={onClick}>
      <div
        className={`h-9 pl-10 pr-2 py-3.5 rounded-xl flex justify-between items-center relative ${isActive ? 'bg-[#151717] shadow-[0px_0.375px_0.375px_0px_inset_rgba(255,255,255,0.17)]' : ''} hover:bg-[#151717] hover:shadow-[0px_0.375px_0.375px_0px_inset_rgba(255,255,255,0.17)] transition-all duration-300 ease-out group`}
      >
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <div
            className={`fill-current transition-all duration-300 ease-out flex-shrink-0 ${isActive ? 'text-white' : 'text-[#96A3A3] group-hover:text-white'}`}
          >
            {icon}
          </div>
          <div
            className={`text-sm leading-tight transition-all duration-300 ease-out truncate ${isActive ? 'font-medium text-white' : 'font-medium text-[#96A3A3] group-hover:text-white'}`}
          >
            {label}
          </div>
        </div>
        {showDraftBadge && (
          <div className="bg-[#232626] px-1.5 py-0.5 rounded flex-shrink-0 ml-2">
            <span className="text-[#96A3A3] text-xs font-normal leading-4">
              Draft
            </span>
          </div>
        )}
      </div>
    </Link>
  );
};
